export const RESET_STORE = 'state/RESET_STORE';

export const resetStore = {
  type: RESET_STORE,
};
